import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { faqs } from "@/content";
import { Reveal } from "@/components/Reveal";

export default function FAQSection() {
  const [open, setOpen] = useState(0);
  return (
    <section className="section faq-section" id="perguntas-frequentes" data-testid="faq-section">
      <div className="section-shell faq-layout">
        <Reveal className="faq-intro"><p className="eyebrow">ANTES DE DECIDIR</p><h2>Perguntas honestas merecem respostas claras.</h2><p>Se a situação estiver urgente, procure alguém de confiança e um serviço de saúde. O livro é um apoio, não uma emergência.</p></Reveal>
        <Reveal className="faq-list" delay={90}>
          {faqs.map((item, index) => <div className={`faq-item ${open === index ? "is-open" : ""}`} key={item.question}><button type="button" onClick={() => setOpen(open === index ? -1 : index)} aria-expanded={open === index} data-testid={`faq-question-${index + 1}`}><span>{item.question}</span><ChevronDown size={18} /></button>{open === index && <div className="faq-answer" data-testid={`faq-answer-${index + 1}`}>{item.answer}</div>}</div>)}
        </Reveal>
      </div>
    </section>
  );
}
